import { render } from "./PopUpEditAiGeneratedQCM.vue?vue&type=template&id=4327ff26"
import script from "./PopUpEditAiGeneratedQCM.vue?vue&type=script&lang=js"
export * from "./PopUpEditAiGeneratedQCM.vue?vue&type=script&lang=js"

import "./PopUpEditAiGeneratedQCM.vue?vue&type=style&index=0&id=4327ff26&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__